"use client";
import React, { useEffect, useRef, useState } from "react";
import styles from "./WipTransferModal.module.scss";
// test build

export default function WipTransferModal({ open, onClose, managerEmail }) {
  const [mounted, setMounted] = useState(false);
  const [leaving, setLeaving] = useState(false);
  const closeRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    setMounted(true);

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    setTimeout(() => closeRef.current?.focus(), 0);

    const onKey = (e) => e.key === "Escape" && handleClose();
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener("keydown", onKey);
      setLeaving(false);
      setMounted(false);
    };
  }, [open]);

  if (!open && !mounted) return null;

  const handleClose = () => {
    // pokreni exit animaciju pa unmount
    setLeaving(true);
    setTimeout(() => {
      setMounted(false);
      onClose();
    }, 220); // uskladjeno s .22s/.26s iz CSS-a
  };

  const subject = "VIP Transfer Request - [Your name/username]";
  const body = [
    "Hello,",
    "",
    "[Please fill in the details required in this form and you may delete this sentence.]",
    "",
    "I would like to request a VIP Transfer to your casino.",
    "Please find my details below:",
    "Personal Details:",
    "",
    "• Username:",
    "• Registered Email:",
    "• Current Casino:",
    "",
    "Current VIP Information:",
    "",
    "• VIP Level / Tier:",
    "• Main VIP Benefits (cashback %, withdrawal limits, bonuses, etc.):",
    "",
    "Verification:",
    "",
    "• I have attached screenshots confirming my current VIP status and benefits.",
    "",
    "I understand that a $200 qualifying deposit is required to initiate the transfer process and open discussions regarding my upgraded terms.",
    "",
    "Please advise on the next steps.",
    "",
    "Kind regards,",
    "[Your name]",
  ].join("\n");

  const mailto = `mailto:${encodeURIComponent(managerEmail)}?subject=${encodeURIComponent(
    subject,
  )}&body=${encodeURIComponent(body)}`;

  return (
    <div
      // className={styles.backdrop}
      className={`${styles.backdrop} ${leaving ? styles.fadeOut : ""}`}
      role="presentation"
      onClick={handleClose}
      aria-hidden="true"
    >
      <div
        id="wip-transfer-modal"
        // className={styles.modal}
        className={`${styles.modal} ${leaving ? styles.modalOut : ""}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="wip-title"
        aria-describedby="wip-desc"
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.header}>
          <h3 id="wip-title">VIP Transfer</h3>
          <button
            ref={closeRef}
            className={styles.close}
            onClick={handleClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <div id="wip-desc" className={styles.content}>
          <p>
            The <b>VIP Transfer Program</b> is an exclusive offer for high-tier
            players from other casinos who wish to explore our brand under
            superior conditions. It is designed to ensure continuity of
            experience, elevated service standards, and privileged access from
            the very first moment of onboarding.
          </p>

          <p>
            <b>Program Benefits:</b>
          </p>

          <ul className={styles.bullets}>
            <li>Immediate VIP status upon verification</li>
            <li>Personalized bonus structure</li>
            <li>Increased withdrawal and betting limits</li>
            <li>Dedicated account management</li>
            <li>Private onboarding handled directly by management</li>
            <li>Discreet and confidential transfer process</li>
          </ul>

          <p>
            <b>Entry Requirement:</b>
          </p>

          <p>
            Minimum single deposit: <b>$200</b>
          </p>

          <p>
            If you are an active VIP player at another casino and wish to
            discuss a confidential status transfer, please contact our
            management team to receive your personalized offer.
          </p>
        </div>

        <div className={styles.actions}>
          <a
            className={styles.primary}
            href={mailto}
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact Management (Email)
          </a>
          <button className={styles.secondary} onClick={handleClose}>
            Deposit
          </button>
        </div>
      </div>
    </div>
  );
}
